var LeafletDirectiveWrapper = (function () {
    function LeafletDirectiveWrapper(leafletDirective) {
        this.leafletDirective = leafletDirective;
    }
    LeafletDirectiveWrapper.prototype.init = function () {
        // Nothing for now
    };
    LeafletDirectiveWrapper.prototype.getMap = function () {
        return this.leafletDirective.getMap();
    };
    return LeafletDirectiveWrapper;
}());
export { LeafletDirectiveWrapper };
//# sourceMappingURL=leaflet.directive.wrapper.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/@asymmetrik/angular2-leaflet/dist/leaflet/core/leaflet.directive.wrapper.js
// module id = ../../../../@asymmetrik/angular2-leaflet/dist/leaflet/core/leaflet.directive.wrapper.js
// module chunks = 3